import { SVGProps } from 'react';
import {
  IconBuilding,
  IconEmployee,
  IconPin,
  IconReserveBox,
  IconShield,
  IconToolWrench
} from '../assets/DesignSystem/SVGComponents';
import { IlogisticServiceLocation, LOCATION_PLACE_TYPE } from '../types/services';

export const getLocationDisplayData = (
  locationData?: IlogisticServiceLocation | null,
  props?: SVGProps<SVGSVGElement>
) => {
  const flag = `url(${locationData?.country?.flag})`;
  switch (locationData?.place) {
    case LOCATION_PLACE_TYPE.USER:
      return { flag, icon: <IconEmployee className="IconEmployee" viewBox={props?.viewBox} /> };
    case LOCATION_PLACE_TYPE.OFFICE:
      return { flag, icon: <IconBuilding className="IconBuilding" viewBox={props?.viewBox} /> };
    case LOCATION_PLACE_TYPE.OTHER:
      return { flag, icon: <IconPin className="IconPin" viewBox={props?.viewBox} /> };
    case LOCATION_PLACE_TYPE.WARRANTY:
      return { flag, icon: <IconShield className="IconShield" viewBox={props?.viewBox} /> };
    case LOCATION_PLACE_TYPE.DIAGNOSTIC:
      return { flag, icon: <IconToolWrench className="IconToolWrench" viewBox={props?.viewBox} /> };
    case LOCATION_PLACE_TYPE.NUDOS:
      return { flag, icon: <IconReserveBox className="IconReserveBox" viewBox={props?.viewBox} /> };
    default:
      return { flag, icon: <IconPin viewBox={props?.viewBox} /> };
  }
};
